import React, { useState, useRef } from 'react';

interface OtpInputProps {
  length: number;
  onComplete: (otp: string) => void;
}

export const OtpInput: React.FC<OtpInputProps> = ({ length, onComplete }) => {
  const [otp, setOtp] = useState<string[]>(Array(length).fill(''));
  const inputs = useRef<Array<HTMLInputElement | null>>([]);

  const handleChange = (element: HTMLInputElement, index: number) => {
    const value = element.value;
    if (/^\d$/.test(value)) { // Accept only digits
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input automatically
      if (index < length - 1) {
        // newOtp[index+1] = ''; 
        inputs.current[index + 1]?.focus();
        inputs.current[index + 1]?.select();
      }

      // Call onComplete when OTP is fully filled
      if (newOtp.every((digit) => digit !== '')) {
        // alert(`${index+1} - ${length}`);
        if((index+1)  === length){
          onComplete(newOtp.join(''));
        }
      }
    }
  };

  const handleBackspace = (event: React.KeyboardEvent, index: number) => {
    if (event.key === 'Backspace' || event.code === 'Backspace') {
      if (index > 0) {
        const newOtp = [...otp];
        newOtp[index] = ''; 
        newOtp[index-1] = ''; 
        setOtp(newOtp);
        inputs.current[index - 1]?.focus();
      }
    }
  };

  const handleFocus = (index: number) => {
    if (inputs.current[index]) {
      inputs.current[index]?.select();
    }
  }; 

  const pasteOtp=(event:any)=>{
    const pasteData=event.clipboardData?.getData('text/plain')?.trim();
    if(pasteData<=999999 && pasteData.length===length){
      const otpdata=pasteData?.split('').map((e:any)=>+e)
      setOtp(otpdata);
    // Move to next input automatically
      inputs.current[otpdata.length-1]?.focus();
      inputs.current[otpdata.length-1]?.select();

    // Call onComplete when OTP is fully filled
    if (otpdata.every((digit:any) => digit !== '')) {
      // alert(`${index+1} - ${length}`);
      if(otpdata.length  === length){
        onComplete(pasteData);
      }
    }
    }else{
      return
    }
  }

  return (
    <>
    <p className='fs-14 fw-500 text-secondary m-0 mb-2'>
      Enter OTP
    </p>
    <div style={{ display: 'flex', justifyContent: 'between', gap: '10px' }}>
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e.target, index)}
          onKeyDown={(e) => handleBackspace(e, index)}
          onClick={() => handleFocus(index)}
          onPaste={(event)=>pasteOtp(event)}
          style={{
            width: '56px',
            height: '56px',
            textAlign: 'center',
            fontSize: '20px',
            border: '1px solid #ccc',
            borderRadius: '4px',
          }}
        />
      ))}
    </div>
    {/* <p className='fs-14 fw-500 text-secondary m-0 mt-2'>
      Didn't recieve OTP <span className='text-primary pointer'>Resend Otp</span>
    </p> */}
    </>
  );
};